// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var DomUtils = require("../shared/utils/DomUtils.bs.js");
var ReactDOMRe = require("reason-react/src/legacy/ReactDOMRe.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");
var StudentTopNav = require("../layouts/student/StudentTopNav.bs.js");
var StudentTopNav__NavLink = require("../layouts/student/types/StudentTopNav__Types/StudentTopNav__NavLink.bs.js");

function decodeProps(json) {
  return {
          schoolName: Json_decode.field("schoolName", Json_decode.string, json),
          logoUrl: Caml_option.null_to_opt(Json_decode.field("logoUrl", (function (param) {
                      return Json_decode.nullable(Json_decode.string, param);
                    }), json)),
          links: Json_decode.field("links", (function (param) {
                  return Json_decode.list(StudentTopNav__NavLink.decode, param);
                }), json),
          frameLinks: Json_decode.field("frameLinks", (function (param) {
                  return Json_decode.list(StudentTopNav__NavLink.decode, param);
                }), json),
          isLoggedIn: Json_decode.field("isLoggedIn", Json_decode.bool, json)
        };
}

var props = decodeProps(DomUtils.parseJSONTag("student-top-nav-props", undefined));

ReactDOMRe.renderToElementWithId(React.createElement(StudentTopNav.make, {
          schoolName: props.schoolName,
          logoUrl: props.logoUrl,
          links: props.links,
          frameLinks: props.frameLinks,
          isLoggedIn: props.isLoggedIn
        }), "student-top-nav");

exports.decodeProps = decodeProps;
exports.props = props;
/* props Not a pure module */
